module.exports = __webpack_public_path__ + "images/nav/line-3.png";